module.exports = __webpack_public_path__ + "img/qr-code_qywx.2e7ba23f.png";